import './PreventiveFilters.scss';

import { useSelector } from "react-redux";

import { useGetPreventiveFilters } from "../../../hooks/useGetPreventiveFilters";
import { useGetPreventiveFiltersWithOptions } from "../../../hooks/useGetPreventiveFiltersWithOptions";

import { FilterField } from "../../../common-components/FilterField/FilterField";

const PreventiveFilters = () => {
    const componentId = "preventive";
    const token = useSelector((state) => state.auth.token);
    const { filters: rawFilters } = useGetPreventiveFilters();
    const { filters } = useGetPreventiveFiltersWithOptions(rawFilters, token);

    if (!filters) {
        return null
    }

    return (
        <div className={"preventive-filters"}>
            <div className={"preventive-filters_container"}>
                <div className={"preventive-filters_items"}>
                    {Object.entries(filters).map(([filterKey, filter]) => (
                        <FilterField
                            name={filter.name}
                            key={filterKey}
                            label={filter.label || filter.alias}
                            type={filter.type}
                            propertyLabel={filter.alias || filter.label}
                            filterKey={filter.filterKey}
                            componentId={componentId}
                            filterStructure={filter}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PreventiveFilters;